<template>
    <div class="toast" v-show="showToast">
      {{ message }}
    </div>
</template>
<script>
export default {
  data() {
    return {
      showToast: false,
      message: "消息提示",
      duration: 3000,
    };
  },
  methods: {
    show(message = "默认", duration = 3000) {
      this.showToast = true;
      this.message = message;
      setTimeout(() => {
        this.showToast = false;
        this.message = "";
      }, duration);
    },
  },
};
</script>
<style lang="scss" scoped>
.toast {
    z-index: 999;
  position: fixed;
  left: 50%;
  top: 50%;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 20px;
  z-index: 1000;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 26px;
  padding: 30px 71px;
  text-align: center;
  white-space: nowrap;
}
</style>